// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.harvest_annotation_anchor_kind */
var HarvestAnnotationAnchorKind;
(function (HarvestAnnotationAnchorKind) {
    HarvestAnnotationAnchorKind["OPERATION"] = "OPERATION";
    HarvestAnnotationAnchorKind["STREAM"] = "STREAM";
    HarvestAnnotationAnchorKind["KPI"] = "KPI";
    HarvestAnnotationAnchorKind["SAMPLE"] = "SAMPLE";
})(HarvestAnnotationAnchorKind || (HarvestAnnotationAnchorKind = {}));
;
export default HarvestAnnotationAnchorKind;
/** Zod schema for harvest_annotation_anchor_kind */
export const harvestAnnotationAnchorKind = z.nativeEnum(HarvestAnnotationAnchorKind);
//# sourceMappingURL=HarvestAnnotationAnchorKind.js.map